import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { refreshAuthToken } from '@/api';

import { GetPermissionsForm } from '@/interface';

import { applyRefreshedToken, getPermissionsRequest, getUserWithCompanyRequest } from '@/redux/slices';
import type { AppDispatch, RootState } from '@/redux/store';

import { configureTokenRefresh, syncTokenRefreshFromStorage } from '@/utils/tokenRefresh';

export const useAuthInit = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { userId, companyId } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    configureTokenRefresh({
      refresh: async () => {
        const response = await refreshAuthToken();
        return response.data.access_token ?? null;
      },
      onTokenUpdated: (token) => {
        dispatch(applyRefreshedToken(token));
      },
    });
    syncTokenRefreshFromStorage();
  }, [dispatch]);

  useEffect(() => {
    if (!userId) return;

    dispatch(getUserWithCompanyRequest());

    const data: GetPermissionsForm = {
      userId,
      ...(companyId && { companyId }),
    };

    dispatch(getPermissionsRequest({ data }));
  }, [dispatch, userId, companyId]);
};
